import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { TurmaModel } from '@/features/list-turma/types';

type Params = {
  serie_nome?: string;
}

async function getTurma(serieNome): Promise<TurmaModel[]> {
  const api = await getApi();
  const params = { } as Params
  if (serieNome) {
    params.serie_nome = serieNome;
  }
  const { data } = await api.get('/escola/turmas/turma_nomes/', {params});
  return data;
}

type QueryFnType = typeof getTurma;

function useTurmas(serieId) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-turmas', serieId],
    queryFn: () => getTurma(serieId),
  });
}

export { getTurma, useTurmas };
